import { Flex, Text, VStack } from "@chakra-ui/react";
import { apiJWT } from "api/api-jwt";
import { CustomModal } from "components/custom-modal";
import { ButtonWithLoading } from "components/mailing-components/mailing-table/icon-button-with-loading";
import { CloseIcon } from "components/vectors/close-icon";
import { modalTutorialPipelineData } from "contexts/notification-context";
import { createModalTrigger, useModalControls } from "hooks/use-modal-controls";
import { useEffect } from "react";

const eventName = "open-tutorial-pipeline-modal";
export const openModalTutorialPipeline = createModalTrigger(eventName);

const steps = [
  {
    number: 1,
    title: "Adicione processamento",
    description: "Higienize, filtre e escolha os canais necessários"
  },
  {
    number: 2,
    title: "Conecte os blocos",
    description: "Arraste a bolinha de saída para a entrada do próximo bloco"
  },
  {
    number: 3,
    title: "Finalize com o bloco Fim",
    description:
      'Todo fluxo deve terminar no bloco Fim. Após montar o fluxograma, clique no botão "Criar Pipeline" para salvar'
  }
];

export function TutorialPipelineModal() {
  const { isOpen, onClose, onOpen } = useModalControls(eventName);

  useEffect(() => {
    if (
      modalTutorialPipelineData.id &&
      modalTutorialPipelineData.lida === false
    ) {
      onOpen();
    }
  }, []);

  const markAsRead = async () => {
    try {
      await apiJWT.get(`/notifications/read/${modalTutorialPipelineData.id}`);
      modalTutorialPipelineData.lida = true;
      onClose();
    } catch (e) {
      //
    }
  };

  return (
    <CustomModal
      isOpen={isOpen}
      onClose={onClose}
      size="5xl"
      modalFooter={
        <>
          <ButtonWithLoading
            onClick={markAsRead}
            leftIcon={<CloseIcon />}
            loadingText="Marcando como lida..."
          >
            Não exibir novamente
          </ButtonWithLoading>
        </>
      }
    >
      <VStack spacing={8} py={8} px={4} textAlign="center">
        <VStack spacing={2}>
          <Text fontSize="2xl" fontWeight="bold" color="gray.800">
            Vamos criar seu primeiro pipeline em 3 passos
          </Text>
          <Text fontSize="md" color="gray.500">
            Arraste blocos da lateral esquerda para construir um fluxo de
            prospecção automatizado
          </Text>
        </VStack>

        <Flex
          w="100%"
          justify="space-between"
          gap={6}
          flexWrap={{ base: "wrap", md: "nowrap" }}
        >
          {steps.map((step) => (
            <VStack key={step.number} flex={1} spacing={4} minW="160px">
              <Flex
                w="70px"
                h="70px"
                borderRadius="full"
                bg="blue.50"
                border={`4px solid var(--chakra-colors-blue-100)`}
                align="center"
                justify="center"
                flexShrink={0}
              >
                <Text fontSize="2xl" fontWeight="bold" color="blue.600">
                  {step.number}
                </Text>
              </Flex>

              <VStack spacing={2}>
                <Text fontWeight="bold" color="gray.800" fontSize="md">
                  {step.title}
                </Text>
                <Text fontSize="sm" color="gray.500" lineHeight="1.5">
                  {step.description}
                </Text>
              </VStack>
            </VStack>
          ))}
        </Flex>
      </VStack>
    </CustomModal>
  );
}
